import FullScreenPanel from "app/ui/FullScreenPanel";
import { useCallback, useEffect } from "react";
import TutorialLevelList from "./TutorialLevelList";
import type { TutorialLevel } from "./tutorial-data";
import { TutorialAction, useTutorialActionDispatch } from "./useTutorialState";

interface TutorialSelectProps {
  onLevelSelected: () => void;
  onDismiss: () => void;
}

// The panel that appears when the player enters the tutorial mode from the
// game menu.
export default function TutorialSelect({
  onLevelSelected,
  onDismiss,
}: TutorialSelectProps) {
  const tutorialDispatch = useTutorialActionDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLevelSelected = useCallback(
    (levelData: TutorialLevel) => {
      onLevelSelected();
      tutorialDispatch({
        type: TutorialAction.START_TUTORIAL_LEVEL,
        payload: { levelData },
      });
    },
    [onLevelSelected, tutorialDispatch],
  );

  return (
    <FullScreenPanel
      heading="Choose a tutorial"
      headingClassName="px-9 pb-5"
      panelClassName="md:h-auto lg:h-auto shrink"
      childDivClassName="flex-col justify-start items-center gap-2 h-full pb-5"
      onClose={onDismiss}
    >
      <TutorialLevelList
        className="md:px-8"
        onLevelSelected={handleLevelSelected}
        isInOnboardingFlow={false}
      />
    </FullScreenPanel>
  );
}
